import React from 'react';
import { useTranslation } from 'react-i18next';
import { SUPPORTED_LANGUAGES, normalizeLanguage } from '../../i18n/locales';

function LanguageSelector({ className = '', compact = false }) {
	const { t, i18n } = useTranslation();
	const selectedLanguage = normalizeLanguage(i18n.resolvedLanguage || i18n.language);

	return (
		<label className={`flex items-center gap-2 ${className}`.trim()}>
			<span className="text-xs font-semibold uppercase tracking-wide text-gray-500">
				{t('common.languageSelectorLabel')}
			</span>
			<select
				value={selectedLanguage}
				onChange={(event) => i18n.changeLanguage(event.target.value)}
				aria-label={t('common.languageSelectorLabel')}
				className={`rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm font-medium text-gray-700 shadow-sm focus:border-sky-500 focus:outline-none focus:ring-2 focus:ring-sky-500 ${compact ? 'min-w-[84px]' : 'min-w-[120px]'}`}
			>
				{SUPPORTED_LANGUAGES.map((language) => (
					<option key={language} value={language}>
						{compact ? t(`common.languageShort.${language}`) : t(`common.languageName.${language}`)}
					</option>
				))}
			</select>
		</label>
	);
}

export default LanguageSelector;